import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { Costanti } from 'app/main/utils/costanti';

@Injectable()
export class WelcomeService {
  private BASEURL = Costanti.APIURL;

  protected loadingSubject = new BehaviorSubject(false);
  loading$ = this.loadingSubject.asObservable();

  constructor(private http: HttpClient) {}

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

  private extractData(res) {
    return res['data'] || {};
  }

  getBaseUrl() {
    return this.BASEURL;
  }

  getNavigation() {
    const url = this.BASEURL + 'guide/get-guide';
    this.loadingSubject.next(true);
    const body = {};

    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getGuida(id_guida) {
    const url = this.BASEURL + 'guide/get-dettaglio-guida';
    this.loadingSubject.next(true);
    const body = { id_guida };

    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getLinkEvidenza() {
    const url = this.BASEURL + 'welcome-page/get-link-evidenza';
    this.loadingSubject.next(true);
    const body = {};

    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
}
